import { Center } from '@chakra-ui/react'
import { CompanyProfileForm } from '@src/components/sco/Account/CompanyProfileForm'
import {
  MatchingSignupNav,
  matchingSignupNavItems,
} from '@src/components/sco/Matching/Layout/MatchingSignupNav'
import { OnboardingLayout } from '@src/components/sco/Onboarding/Layout/OnboardingLayout'
import { OnboardingMainPanel } from '@src/components/sco/Onboarding/Layout/OnboardingMainPanel'
import { useState } from 'react'

export default function Page() {
  const [submitTrigger, setSubmitTrigger] = useState(0)

  return (
    <OnboardingLayout
      navItems={matchingSignupNavItems}
      navPanel={<MatchingSignupNav />}
      mainPanel={
        <OnboardingMainPanel onNext={() => setSubmitTrigger(x => x + 1)}>
          <Center margin={'auto'} maxWidth={'container.md'} minHeight={'80vh'} paddingY={'2em'}>
            <CompanyProfileForm
              returnToHref={`/members/matching/signup/skills`}
              submitTrigger={submitTrigger}
              title={'What are you working on?'}
            />
          </Center>
        </OnboardingMainPanel>
      }
    />
  )
}
